var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.kioskConfigurator },
    [
      _c("Configurator", { class: _vm.$style.configuratorMain }),
      _vm._v(" "),
      _c(
        "KioskModal",
        {
          attrs: { show: _vm.isHelpModalShow, "max-width": "317px" },
          on: {
            close: function($event) {
              return _vm.hideHelp()
            }
          }
        },
        [_c("HelpModal")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskConfigurator.vue?vue&type=template&id=95f85782&
// module id = null
// module chunks = 